import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";

import { ProgressiveImage } from "components";
import { selectFocusedPhotos, getButtonBgColor, setFocusedPhotoIdx, selectFocusedPhoto, getSelectedBadgePhotoId } from "slices";
import { getIsMaximized } from "slices/window-slice/index";

const PhotosRow = () => {
  const dispatch = useDispatch();
  const isMaximized = useSelector(getIsMaximized);

  const photos = useSelector(selectFocusedPhotos);
  const color = useSelector(getButtonBgColor);
  const focusedPhotos = useSelector(selectFocusedPhoto);
  const selectedId = useSelector(getSelectedBadgePhotoId);

  const onClickTourItem = (idx) => {
    const eventHash = {
      event_name: "h_click",
      event_params: {
        h_page_type: "hayley",
        h_display_method: "iframe",
        h_clicked_location: `${selectedId} photo`,
        h_click_value: photos[idx]?.name,
      },
    };

    window.parent.postMessage(JSON.stringify(eventHash), "*");
    dispatch(setFocusedPhotoIdx(idx));
  };

  return (
    <div
      className={`!hayley-mt-4 ${
        isMaximized ? "pl-2" : ""
      } hayley-hidden hayley-h-fit hayley-w-full hayley-flex-none hayley-flex-nowrap hayley-items-center hayley-space-x-8 hayley-overflow-x-auto sm:hayley-flex`}
    >
      {Object.keys(photos || {}).map((key, idx) => (
        <Box key={idx} className="hayley-h-fit hayley-w-fit hayley-space-y-1 sm:!hayley-mx-1.5">
          <Box className="hayley-relative">
            <ProgressiveImage
              classes={{ root: "hayley-h-[70px] hayley-w-[110px] sm:hayley-h-[100px] sm:hayley-w-[160px] hayley-overflow-hidden" }}
              src={photos[key]?.thumbnail_url}
              alt={photos[key]?.name}
              selectedId={selectedId}
              testId={`photosView_row_${selectedId}_image`}
              meta={photos[key]}
            />

            <Box
              className={`hayley-custom hayley-absolute hayley-left-0 hayley-top-0 hayley-flex hayley-h-full hayley-w-full hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-border hayley-border-solid hayley-border-transparent ${
                focusedPhotos.thumbnail_url == photos[key]?.thumbnail_url && " hayley-border-2 !hayley-border-[#999999]"
              }`}
              sx={{ "&.hayley-custom:hover": { borderColor: `${color} !important` } }}
              onClick={() => onClickTourItem(idx)}
              data-testid={`photosView_row_${selectedId}_container`}
            />
          </Box>
        </Box>
      ))}
    </div>
  );
};

export default PhotosRow;
